module.exports = {
  "id": "anthill",
  "title": "anthill",
  "image": "provision/parts/anthill/anthill.png",
  "info": [
    {
      "text": "Add an anthill to your project",
      "image": "provision/parts/anthill/anthill.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/anthill/anthill.png"
} ;